(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-combobox"] = factory(require("vue"));
	else
		root["vue-combobox"] = factory(root["Vue"]);
})((typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE__203__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 570:
/***/ (function(module) {

!function(e,n){ true?module.exports=n():0}(this,function(){var e="__v-click-outside",n="undefined"!=typeof window,t="undefined"!=typeof navigator,r=n&&("ontouchstart"in window||t&&navigator.msMaxTouchPoints>0)?["touchstart"]:["click"];function i(e){var n=e.event,t=e.handler;(0,e.middleware)(n)&&t(n)}function a(n,t){var a=function(e){var n="function"==typeof e;if(!n&&"object"!=typeof e)throw new Error("v-click-outside: Binding value must be a function or an object");return{handler:n?e:e.handler,middleware:e.middleware||function(e){return e},events:e.events||r,isActive:!(!1===e.isActive),detectIframe:!(!1===e.detectIframe),capture:!!e.capture}}(t.value),d=a.handler,o=a.middleware,c=a.detectIframe,u=a.capture;if(a.isActive){if(n[e]=a.events.map(function(e){return{event:e,srcTarget:document.documentElement,handler:function(e){return function(e){var n=e.el,t=e.event,r=e.handler,a=e.middleware,d=t.composedPath&&t.composedPath()||t.path;(d?d.indexOf(n)<0:!n.contains(t.target))&&i({event:t,handler:r,middleware:a})}({el:n,event:e,handler:d,middleware:o})},capture:u}}),c){var l={event:"blur",srcTarget:window,handler:function(e){return function(e){var n=e.el,t=e.event,r=e.handler,a=e.middleware;setTimeout(function(){var e=document.activeElement;e&&"IFRAME"===e.tagName&&!n.contains(e)&&i({event:t,handler:r,middleware:a})},0)}({el:n,event:e,handler:d,middleware:o})},capture:u};n[e]=[].concat(n[e],[l])}n[e].forEach(function(t){var r=t.event,i=t.srcTarget,a=t.handler;return setTimeout(function(){n[e]&&i.addEventListener(r,a,u)},0)})}}function d(n){(n[e]||[]).forEach(function(e){return e.srcTarget.removeEventListener(e.event,e.handler,e.capture)}),delete n[e]}var o=n?{bind:a,update:function(e,n){var t=n.value,r=n.oldValue;JSON.stringify(t)!==JSON.stringify(r)&&(d(e),a(e,{value:t}))},unbind:d}:{};return{install:function(e){e.directive("click-outside",o)},directive:o}});
//# sourceMappingURL=v-click-outside.umd.js.map


/***/ }),

/***/ 203:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__203__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "";
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  VueCombobox: () => (/* reexport */ VueCombobox),
  VueComboboxOption: () => (/* reexport */ VueComboboxOption)
});

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ const setPublicPath = (null);

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!../../node_modules/pug-plain-loader/index.js!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueCombobox.vue?vue&type=template&id=22c113f6&scoped=true&lang=pug&
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.clickOutsideSelect),expression:"clickOutsideSelect"}],staticClass:"sf-combobox",class:{ 'sf-combobox--open': _vm.dropdownVisible || _vm.isEmpty, 'sf-combobox--error': _vm.hasError },style:({ maxWidth: _vm.maxWidthStyle })},[_c('div',{staticClass:"sf-combobox__input-wrapper",attrs:{"role":"combobox","aria-expanded":_vm.dropdownVisible ? '' + true : '' + false,"aria-owns":`${_vm.uuid}-combobox-list-wrapper`,"aria-haspopup":"listbox"}},[_c('input',{ref:"text-input",staticClass:"sf-combobox__input",class:_vm.$attrs['target-class'],attrs:{"type":"text","id":`${_vm.uuid}`,"autocomplete":"off","aria-autocomplete":"list","aria-describedby":_vm.ariaDescribedBy ? _vm.ariaDescribedBy : false,"aria-invalid":_vm.hasError,"aria-controls":`${_vm.uuid}-combobox-list-wrapper`,"aria-activedescendant":(_vm.queryString && _vm.focusedIndex) || _vm.focusedIndex == 0 ? `${_vm.uuid}-item-${_vm.focusedIndex}` : '',"maxlength":_vm.maxLength},on:{"input":function($event){return _vm.handleInput($event)},"blur":_vm.handleBlur,"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;$event.stopPropagation();$event.preventDefault();return _vm.selectWithEnter.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"]))return null;$event.stopPropagation();return _vm.moveDown($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"]))return null;$event.stopPropagation();return _vm.moveUp($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"]))return null;$event.stopPropagation();return _vm.close.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab"))return null;$event.stopPropagation();return _vm.closeOnTab.apply(null, arguments)}],"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"delete",[8,46],$event.key,["Backspace","Delete","Del"]))return null;$event.stopPropagation();return _vm.checkInputOnDelete($event)},_vm.handleKeyup]}})]),(!_vm.dropdownVisible && _vm.isEmpty)?_c('div',{staticClass:"sf-combobox__empty",attrs:{"aria-hidden":"true"}},[_c('div',{staticClass:"sf-combobox__empty-inner"},[_c('div',{staticClass:"sf-combobox__empty-icon"}),_c('div',{staticClass:"sf-combobox__empty-text",attrs:{"id":_vm.emptyStateId}},[_vm._v(_vm._s(_vm.$t('noResult')))])])]):_vm._e(),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.dropdownVisible),expression:"dropdownVisible"}],ref:"listbox",staticClass:"sf-combobox__list",attrs:{"tabindex":"-1","id":`${_vm.uuid}-combobox-list-wrapper`,"aria-labelledby":_vm.labelId,"role":"listbox"}},[_vm._t("default")],2)])
}
var staticRenderFns = []


// EXTERNAL MODULE: ../../node_modules/v-click-outside/dist/v-click-outside.umd.js
var v_click_outside_umd = __webpack_require__(570);
var v_click_outside_umd_default = /*#__PURE__*/__webpack_require__.n(v_click_outside_umd);
;// CONCATENATED MODULE: ./src/components/VueCombobox.lang.json
const VueCombobox_lang_namespaceObject = JSON.parse('{"hu":{"noResult":"Nem szerepel egyik kiválasztható lehetőségben sem a beírt szöveg."},"en":{"noResult":"No matching results"}}');
;// CONCATENATED MODULE: ../../node_modules/@ui-common/sf-js-utils/dist/sf-js-utils.esm.js
var t=Object.freeze({__proto__:null,ADDRESS_CARD:"^\\d{6}[a-zA-Z]{2}$",ALL_PHONE:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$","^(70|20|30|31)\\s\\d{3}\\s\\d{4}$"],BANK_ACCOUNT_SIXTEEN_NUMBERS:"^\\d{8}-\\d{8}$",BANK_ACCOUNT_THIRTEEN_NUMBERS:"^\\d{5}-\\d{8}$",BANK_ACCOUNT_TWENTY_FOUR_NUMBERS:"^\\d{8}-\\d{8}-\\d{8}$",DATE_SEPARATORS:/[.,\/ -]/,DEVIZA_BANK_ACCOUNT_NUMBER_PATTERN:"^75\\d{3}-\\d{5}88\\d$",FOREIGN_PHONE_REGEX:/^\d{1,3}-\d{1,10}$/,FOREIGN_ZIP_CODE:/^[\da-zA-Z]{1,10}$/g,FULLNAME:"^(.+[ ].+)$|^$",HEX:/#[0-9a-fA-F]{6}/,IDENTITYS:{"personal-id":"^\\d{6}[a-zA-Z]{2}$","drivers-license":"^[a-zA-Z]{2}\\d{6}$",passport:"[a-zA-Z]{2}\\d{7}$"},IOS:/ipad|iphone/i,LANDLINE_PHONES:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$"],LAST_FOUR_DIGITS:/^\d{4}$/,MOBILE_PHONE:"^(70|20|30|31)\\s\\d{3}\\s\\d{4}$",NAME:"^[\\p{L}\\s\\.\\-\\']*$",PENSIONER_NUMBER:"^\\d{3}-\\d{5}-\\d{1}$",TAX_NUMBER:"^\\d{8}-\\d{1}-\\d{2}$",YEAR:"^\\d{4}$",ZIP_CODE:"^\\d{4}$"});var e=Object.freeze({__proto__:null,HUNGARIAN_PHONE_NUMBER_PREFIX:"+36",OTP_BANK_ACCOUNT_NUMBER_PREFIX:"117"});var r=Object.freeze({__proto__:null,COOKIE_GDPR_LEVEL:"gdpr_level",GDPR_LEVELS:{LOW:1,MEDIUM:2,HIGH:3}});var d=Object.freeze({__proto__:null,BACKEND_DATE:"YYYY-MM-DD",DISPLAY_DATE:{hu:"YYYY.MM.DD.",en:"MM/DD/YYYY"},DISPLAY_TIME:{hu:"HH:mm",en:"hh:mm A"}});function i(){window.onkeydown=function(t){"Space"===t.code&&t.target==document.body&&t.preventDefault()}}function o(t){for(var e=0,r=0;t;){if("BODY"==t.tagName){var d=t.scrollLeft||document.documentElement.scrollLeft,i=t.scrollTop||document.documentElement.scrollTop;e+=t.offsetLeft-d+t.clientLeft,r+=t.offsetTop-i+t.clientTop}else e+=t.offsetLeft-t.scrollLeft+t.clientLeft,r+=t.offsetTop-t.scrollTop+t.clientTop;t=t.offsetParent}return{x:e,y:r}}function s(t){let e=[],r=t.parentNode.firstChild;for(;r;)1===r.nodeType&&r!==t&&e.push(r),r=r.nextSibling;return e}function n(t,e,r){return r=r?parseInt(r,10):0,"number"==typeof e?t.slice(r,r+e):t}function p(t){return void 0!==t&&null!=t?Math.floor(t/12)+" év":""}const u=767,_=959,h=1279;var a={data:()=>({viewportWidth:null}),methods:{setViewportWidth(){this.viewportWidth=window.innerWidth}},computed:{isMobile(){return this.viewportWidth<=u},isTablet(){return this.viewportWidth>u&&this.viewportWidth<_},isDesktop(){return this.viewportWidth>_&&this.viewportWidth<h},isLargeDesktop(){return this.viewportWidth>h}},created(){window.addEventListener("resize",this.setViewportWidth),this.setViewportWidth()},mounted(){this.setViewportWidth()},beforeDestroy(){window.removeEventListener("resize",this.setViewportWidth)}},E=(t=8)=>{let e="";const r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";for(let d=0;d<t;d++)e+=r.charAt(Math.floor(62*Math.random()));return e},l={data(){return{uuid:this.id||E()}},props:{id:{required:!1,type:String}}},N={mixins:[l],props:{errorId:{required:!1,type:String},addonId:{required:!1,type:String},prefixId:{required:!1,type:String},tooltipId:{required:!1,type:String},addon:{type:String,required:!1},prefix:{type:String,required:!1}},computed:{computedAddonId(){const t=this.addon?`${this.uuid}-addon`:null;return this.addonId||t},computedPrefixId(){const t=this.prefix?`${this.uuid}-prefix`:null;return this.prefixId||t},ariaDescribedBy(){const t=[];return this.$attrs["aria-describedby"]&&t.push(this.$attrs["aria-describedby"]),this.errorId&&t.push(this.errorId),this.computedAddonId&&t.push(this.computedAddonId),this.computedPrefixId&&t.push(this.computedPrefixId),this.tooltipId&&t.push(this.tooltipId),t.join(" ")}}},c={props:{hasError:{type:Boolean,required:!1,default:!1}}};

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(203);
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueCombobox.vue?vue&type=script&lang=js&





/* harmony default export */ const VueComboboxvue_type_script_lang_js_ = ({
	mixins: [l, c, a],
	name: 'VueCombobox',
	inheritAttrs: false,
	data() {
		return {
			eventBus: new (external_commonjs_vue_commonjs2_vue_root_Vue_default())(),
			selected: '',
			selectedText: null,
			focusedIndex: null,
			queryString: '',
			dropdownVisible: false,
			isEmpty: false
		};
	},
	i18n: { messages: VueCombobox_lang_namespaceObject },
	directives: {
		clickOutside: (v_click_outside_umd_default()).directive
	},
	props: {
		/**
		 *Id of the label
		 */
		labelId: {
			type: String,
			required: false
		},
		/**
		 * @model
		 */
		value: {
			required: true
		},
		/**
		 * Text of the placeholder
		 */
		placeholder: {
			type: String,
			required: false
		},
		/**
		 * Method functionality that comes outside
		 */
		remoteMethod: {
			required: true,
			type: Function
		},
		/**
		 * The maximum width of the input
		 */
		maxWidth: {
			type: Number
		},
		/**
		Full width on mobile
		*/
		fullWidthMobile: {
			type: Boolean
		},
		/**
		 * Makes sure to use the current input value and updates the model, even if it isn't matched by the remote method.
		 */
		useInputValue: {
			type: Boolean,
			required: false,
			default: false
		},
		/**
		 * Maximum length of input text
		 */
		maxLength: {
			type: Number,
			required: false
		}
	},
	watch: {
		queryString() {
			this.setIsEmpty();
		},
		value: {
			handler(val) {
				this.$nextTick(() => {
					if (this.$refs['text-input']) {
						this.$refs['text-input'].value = val;
					}
				});
			},
			immediate: true
		}
	},
	computed: {
		emptyStateId() {
			return this.isEmpty ? `sf-combobox-empty-${this._uid}` : null;
		},
		ariaDescribedBy() {
			let items = [this.$attrs['aria-describedby'], this.emptyStateId];
			return items.filter((item) => item != undefined).join(' ');
		},
		focusedId() {
			let postfix = this.focusedIndex == null ? 'please' : this.focusedIndex;
			return `${this.uuid}-item-${postfix}`;
		},
		maxWidthStyle() {
			return this.fullWidthMobile && this.isMobile && this.maxWidth ? null : `${this.maxWidth}px`;
		}
	},
	methods: {
		handleInput(e) {
			this.queryString = e.target.value;
			this.remoteMethod(this.queryString);
		},
		handleBlur() {
			this.$emit('blur');
		},
		handleKeyup(e) {
			this.useInputValue && this.$emit('input', e.target.value);
		},
		getText(index) {
			let text;
			if (index == null) {
				text = this.placeholder || '';
			} else {
				text = this.selectedText;
			}
			return text;
		},
		select(index, text, value = null, emit = true) {
			this.focusedIndex = index;
			if (index == null) {
				this.selected = null;
				this.selectedText = this.placeholder;
			} else {
				this.selected = value;
				this.selectedText = text;
			}
			emit && this.$emit('input', this.selected);
			this.$refs['text-input'].value = this.selectedText;
			this.queryString = '';
			this.focusedIndex = null;
			this.remoteMethod('');
		},
		selectWithEnter() {
			this.eventBus.$emit('index-changed', { id: this.uuid, index: this.focusedIndex, emit: true, selectOption: true });
		},
		closeOnTab() {
			this.close();
		},
		clickOutsideSelect() {
			this.close();
		},
		scrollToSelectedItem() {
			this.$nextTick(() => {
				const focusableItem = this.focusedIndex == null ? this.$refs['placeholder'] : this.$children[this.focusedIndex].$el;
				const listbox = this.$refs.listbox;
				if (focusableItem && listbox) {
					listbox.scrollTop = focusableItem.offsetTop;
				}
			});
		},
		close() {
			this.queryString = '';
			this.focusedIndex = null;
			this.remoteMethod('');
		},
		moveDown(e) {
			e.preventDefault();
			if (this.focusedIndex == null) {
				this.focusedIndex = 0;
			} else if (this.focusedIndex < this.$children.length - 1) {
				this.focusedIndex++;
			}
			this.eventBus.$emit('index-changed', { id: this.uuid, index: this.focusedIndex });
			this.$refs.listbox && this.scrollToSelectedItem();
		},
		moveUp(e) {
			e.preventDefault();
			if (this.focusedIndex > 0) {
				this.focusedIndex--;
			}
			this.eventBus.$emit('index-changed', { id: this.uuid, index: this.focusedIndex });
			this.$refs.listbox && this.scrollToSelectedItem();
		},
		checkInputOnDelete() {
			if (!this.queryString) {
				this.$emit('input', this.queryString);
			}
		},
		setIsEmpty() {
			setTimeout(() => {
				this.isEmpty = !this.dropdownVisible && this.queryString;
			}, 200);
		}
	},
	created() {
		this.eventBus.$on('select', ({ id, index, value, text, emit = true, close = true }) => {
			if (id == this.uuid) {
				this.select(index, text, value, emit, close);
			}
		});
		this.eventBus.$on('has-children', (hasChildren) => {
			this.dropdownVisible = hasChildren;
		});
	},
	mounted() {
		this.eventBus.$emit('value-changed', { id: this.uuid, value: this.value });
	},
	beforeDestroy() {
		this.eventBus.$off();
	}
});

;// CONCATENATED MODULE: ./src/components/VueCombobox.vue?vue&type=script&lang=js&
 /* harmony default export */ const components_VueComboboxvue_type_script_lang_js_ = (VueComboboxvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-58.use[0]!../../node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-58.use[1]!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-58.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-58.use[3]!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueCombobox.vue?vue&type=style&index=0&id=22c113f6&prod&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/VueCombobox.vue?vue&type=style&index=0&id=22c113f6&prod&scoped=true&lang=scss&

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/components/VueCombobox.vue



;


/* normalize component */

var component = normalizeComponent(
  components_VueComboboxvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "22c113f6",
  null
  
)

/* harmony default export */ const VueCombobox = (component.exports);
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!../../node_modules/pug-plain-loader/index.js!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueComboboxOption.vue?vue&type=template&id=905f9d1a&scoped=true&lang=pug&
var VueComboboxOptionvue_type_template_id_905f9d1a_scoped_true_lang_pug_render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{ref:`item-${_vm.index}`,staticClass:"sf-combobox__listitem",class:{ 'sf-combobox__listitem--active': _vm.index == _vm.focusedIndex },attrs:{"role":"option","id":`${_vm.$parent.uuid}-item-${_vm.index}`,"aria-selected":_vm.index === _vm.focusedIndex ? '' + true : '' + false},on:{"click":function($event){return _vm.select(_vm.index, _vm.value, _vm.text)}}},[_vm._v(_vm._s(_vm.text))])
}
var VueComboboxOptionvue_type_template_id_905f9d1a_scoped_true_lang_pug_staticRenderFns = []


;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueComboboxOption.vue?vue&type=script&lang=js&


/* harmony default export */ const VueComboboxOptionvue_type_script_lang_js_ = ({
	name: 'VueComboboxOption',
	inheritAttrs: false,
	data() {
		return {
			eventBus: null,
			focusedIndex: null
		};
	},
	directives: {
		clickOutside: (v_click_outside_umd_default()).directive
	},
	props: {
		value: {
			required: true
		},
		text: {
			required: true
		},
		index: {
			required: true
		}
	},
	computed: {},
	methods: {
		select(index, value, text) {
			this.eventBus.$emit('select', { id: this.$parent.uuid, index, value, text, close: true });
		},
		emitHasChildren() {
			this.eventBus.$emit(
				'has-children',
				this.$parent.$children.some((child) => child.$options.name == 'VueComboboxOption')
			);
		}
	},
	created() {
		this.eventBus = this.$parent.eventBus;
		this.eventBus.$on('index-changed', ({ id, index, emit, selectOption }) => {
			if (id == this.$parent.uuid) {
				this.focusedIndex = index;
				if (this.focusedIndex == this.index && selectOption) {
					this.eventBus.$emit('select', { id: this.$parent.uuid, index, value: this.value, text: this.text, emit });
				}
			}
		});
		this.eventBus.$on('value-changed', ({ id, value }) => {
			if (id == this.$parent.id && value == this.value) {
				this.eventBus.$emit('index-changed', { id: this.$parent.id, index: this.index });
			}
		});
	},
	mounted() {
		this.emitHasChildren();
	},
	destroyed() {
		this.emitHasChildren();
	}
});

;// CONCATENATED MODULE: ./src/components/VueComboboxOption.vue?vue&type=script&lang=js&
 /* harmony default export */ const components_VueComboboxOptionvue_type_script_lang_js_ = (VueComboboxOptionvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-58.use[0]!../../node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-58.use[1]!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-58.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-58.use[3]!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueComboboxOption.vue?vue&type=style&index=0&id=905f9d1a&prod&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/VueComboboxOption.vue?vue&type=style&index=0&id=905f9d1a&prod&scoped=true&lang=scss&

;// CONCATENATED MODULE: ./src/components/VueComboboxOption.vue



;


/* normalize component */

var VueComboboxOption_component = normalizeComponent(
  components_VueComboboxOptionvue_type_script_lang_js_,
  VueComboboxOptionvue_type_template_id_905f9d1a_scoped_true_lang_pug_render,
  VueComboboxOptionvue_type_template_id_905f9d1a_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "905f9d1a",
  null
  
)

/* harmony default export */ const VueComboboxOption = (VueComboboxOption_component.exports);
;// CONCATENATED MODULE: ./src/components-export.js





;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js



})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=vue-combobox.umd.js.map